
import { defineComponent, onMounted, reactive } from "vue";
import ErrorList from "@/components/commonDesign/ErrorList.vue";
import { ethitransService } from "@/services/EthitransService";
import { common } from "@/common/services/Common";

export default defineComponent({
  name: "DeleteSelectedModal",
  props: {
    showModal: Boolean,
    folderId: String,
    selectedFiles: {
      type: Array,
    },
  },
  components: {
    ErrorList,
  },
  setup(props, { emit }) {
    // const router = useRouter();
    const state = reactive({
      data: {
        folderRename: "" as any,
        selectedFiles: [] as any,
        folderList: [] as any,
        folderTitle: "folder",
        folderHeading: "No folders created",
      },
      ui: {
        error: {
          hasError: false,
          errorList: {
            delete: [] as any,
          },
        },
        isLoading: {
          getFolderList: false,
        },
        isPostLoading: {
          deleteSelected: false,
        },
      },
    });
    function closeModal(data: any) {
      emit("close", data);
      $("#deleteSelectedFilesModal").modal("hide");
    }
    function deleteSelected() {
      state.ui.error.errorList.delete = [];
      state.ui.error.hasError = false;
      if (
       state.ui.error.errorList.delete.length != 0 ||
        state.ui.error.hasError ||
        state.ui.isPostLoading.deleteSelected
      )
        return false;
        const filesId = [] as any;
        state.data.selectedFiles.forEach((item: any)=> {
          if(item.isChecked){
          filesId.push(item.uuid)
          }
        })
      const payLoad = {
        // eslint-disable-next-line @typescript-eslint/camelcase
        file_id: filesId,
      };

      console.log("PAYLOAD CHECK >>> ", payLoad);
      state.ui.isPostLoading.deleteSelected = true;
      ethitransService
        .fileDelete(payLoad)
        .then((res: any) => {
          console.log("Project List Response Check:>>> ", res.data.data);
          //  closeModal(res.data.data)
           closeModal(filesId)
        })
        .catch((error: any) => {
          // console.log(error);
          common
            .sdCatchErr(error,state.ui.error.errorList.delete)
            .then((res: any) => {
              state.ui.error.hasError = true;
              for (const [key, value] of Object.entries(res)) {
                if (Array.isArray(value)) {
                 state.ui.error.errorList.delete.push(value[0]);
                }
              }
            });
        })
        .finally(() => {
          state.ui.isPostLoading.deleteSelected = false;
        });
    }
    onMounted(() => {
      if (props.showModal) {
        $("#deleteSelectedFilesModal").modal("show");
        state.data.selectedFiles = props.selectedFiles;
      }
      //   getFolderList();
    });

    return {
      state,
      closeModal,
      deleteSelected,
    };
  },
});
